var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBlackDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Download_",
    "data-name": "Download ",
    transform: "translate(-283 -1414)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5329",
    "data-name": "Rectangle 5329",
    width: 16,
    height: 16,
    transform: "translate(283 1414)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Interface_Download",
    "data-name": "Interface / Download",
    transform: "translate(286.269 1415.928)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M6,14.848h9.232M10.616,3v9.215m0,0,3.847-3.291m-3.847,3.291L6.769,8.924",
    transform: "translate(-6 -3)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlackDownload);
export default __webpack_public_path__ + "static/media/blackDownload.9fdb7bc30cf456f95444dc46c3ce223f.svg";
export { ForwardRef as ReactComponent };